import { render } from "./UserAreaV1.vue?vue&type=template&id=5eda1b9e&scoped=true&ts=true"
import script from "./UserAreaV1.vue?vue&type=script&lang=ts"
export * from "./UserAreaV1.vue?vue&type=script&lang=ts"

import "./UserAreaV1.vue?vue&type=style&index=0&id=5eda1b9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eda1b9e"]])

export default __exports__